// extracted by mini-css-extract-plugin
export default {"tags_tech":"TagsTech_tags_tech__+AP4u","title":"TagsTech_title__2gRV5","technologies":"TagsTech_technologies__2Pc1a"};